module.exports = __webpack_public_path__ + "img/leavedates-whoop-strapline-stacked.4e29a105.svg";